<template>
  <div>
    <v-card elevation="0" class="pa-2">
      <div class="text-center text-body-2 gray--text">
        {{ $t('message.memberships_pubic_access_explained') }}
      </div>
      <v-card-actions>
        <v-spacer v-if="!isSmallerDisplay()"></v-spacer>
        <v-btn outlined v-if="!isSmallerDisplay()" small elevation="0" color="primary" class="mr-1"
          @click="configurationDialog = true">
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
        <v-menu offset-y small>
          <template v-slot:activator="{ on }">
            <v-btn outlined :block="isSmallerDisplay()" v-on="on" slot="activator" small elevation="0" color="primary">
              <v-icon class="mr-1">mdi-dots-vertical</v-icon>
              {{ $t("message.actions") }}
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="openMembershipsQRCode()">
              <v-list-item-title>
                <v-icon class="mr-1">mdi-qrcode</v-icon>
                <span>{{ $t("message.print_qr_code") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="copyMembershipsUrl()">
              <v-list-item-title>
                <v-icon class="mr-1">mdi-content-copy</v-icon>
                <span>{{ $t("message.copy_link") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="copyMembershipsEmbedCode()">
              <v-list-item-title>
                <v-icon class="mr-1">mdi-file-code-outline</v-icon>
                <span>{{ $t("message.copy_embed_code") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openMembershipsUrl()">
              <v-list-item-title>
                <v-icon class="mr-1">mdi-open-in-new</v-icon>
                <span>{{ $t("message.open_url") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="configurationDialog = true">
              <v-list-item-title>
                <v-icon>mdi-tune</v-icon>
                <span>{{ $t("message.configuration") }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-actions>
      <div>
        <v-card-actions>
          <v-autocomplete hide-details @change="addPackage" v-model="selectedPackage" :items="availablePackages"
            :label="$t('message.add_package')" item-text="text" item-value="value" clearable outlined
            dense></v-autocomplete>
        </v-card-actions>
        <v-card-actions>
          <v-autocomplete hide-details @change="addMembership" v-model="selectedMembership"
            :items="availableMemberships" :label="$t('message.add_membership')" item-text="text" item-value="value"
            clearable outlined dense></v-autocomplete>
        </v-card-actions>
        <v-card-actions v-if="paymentTypes.length > 0">
          <v-select v-model="selectedPaymentOptions" :items="paymentTypes" small-chips dense attach chips
            :label="$t('message.payment_options')" multiple outlined>
          </v-select>
        </v-card-actions>
        <v-skeleton-loader v-if="loading" type="list-item, list-item">
        </v-skeleton-loader>
        <div v-else class="pa-2">
          <div
            v-if="((!publicMemberships || publicMemberships.length == 0) && (!publicPackages || publicPackages.length == 0))"
            class="text-subtitle-1 text-center">
            {{ $t("message.no_data") }}
          </div>
          <v-card v-else-if="publicPackages && publicPackages.length > 0" elevation="0" outlined class="mb-1">
            <v-subheader>{{ $t('message.packages') }}</v-subheader>
            <div v-for="(element, index) in publicPackages" :key="getGroupKey(element, 'package')" class="clickable">
              <v-list-item v-if="element" outlined @click="doNothing()">
                <v-list-item-content class="text-left">
                  <v-list-item-title v-html="element.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="element.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click="moveOrder(index, true, true)" :disabled="index == 0 ? true : false">
                    <v-icon>mdi-menu-up-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon small @click="moveOrder(index, false, true)"
                    :disabled="index == publicPackages.length - 1 ? true : false">
                    <v-icon>mdi-menu-down-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon small @click="removeElement(element._id, true)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="element"></v-divider>
            </div>
          </v-card>
          <v-card v-if="publicMemberships && publicMemberships.length > 0" elevation="0" outlined>
            <v-subheader>{{ $t('message.memberships') }}</v-subheader>
            <div v-for="(element, index) in publicMemberships" :key="getGroupKey(element)" class="clickable">
              <v-list-item v-if="element" outlined @click="doNothing()">
                <v-list-item-content class="text-left">
                  <v-list-item-title
                    v-html="element.name + (element.type == 'service' ? ' (' + $t('message.automatic') + ')' : '')"></v-list-item-title>
                  <v-list-item-subtitle v-html="element.description"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click="moveOrder(index, true)" :disabled="index == 0 ? true : false">
                    <v-icon>mdi-menu-up-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon small @click="moveOrder(index, false)"
                    :disabled="index == publicMemberships.length - 1 ? true : false">
                    <v-icon>mdi-menu-down-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon small @click="removeElement(element._id)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="element"></v-divider>
            </div>
          </v-card>
        </div>
      </div>
      <v-card-actions>
        <v-btn outlined elevation="0" small color="primary" @click="updatePublicMemberships()">{{ $t('message.update')
        }}</v-btn>
        <v-btn elevation="0" small @click="goBack()">{{ $t('message.back') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="configurationDialog" width="90%">
      <v-card outlined>
        <v-card-title>
          {{ $t('message.configuration') }}
        </v-card-title>
        <v-card-text>
          <v-text-field outlined hide-details :label="$t('message.academy_bill_day')"
            v-model="academyBillDay"></v-text-field>
          <v-switch hide-details v-model="configuration.useBillingDate"
            :label="$t('message.use_academy_bill_date')"></v-switch>
          <div class="text-caption">
            {{ $t('message.use_academy_bill_date_explained') }}
          </div>
          <v-switch :disabled="!configuration.useBillingDate" hide-details v-model="configuration.prorate"
            :label="$t('message.add_prorated_amount')"></v-switch>
          <div :disabled="!configuration.useBillingDate" class="text-caption">
            {{ $t('message.add_academy_bill_date_prorated_amount_explained') }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="primary" @click="updateConfiguration()">
            {{
              $t("message.update")
            }}
          </v-btn>
          <v-btn outlined @click="configurationDialog = false;">
            {{
              $t("message.close")
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import { Environment } from "@/services/Environment";

export default {
  data() {
    return {
      loading: true,
      loadingPackages: false,
      publicMemberships: null,
      publicPackages: null,
      availableMemberships: null,
      membershipsUrl: null,
      selectedPaymentOptions: [],
      allMemberships: {},
      allPackages: {},
      colors: null,
      paymentTypes: [],
      availablePackages: [],
      order: null,
      orderPackages: null,
      selectedMembership: null,
      selectedPackage: null,
      configuration: {},
      configurationDialog: false,
      academyBillDay: null,
    };
  },
  components: {
  },
  created() {
    this.membershipsUrl = "https://core.bjjlink.com/pub/academy/" + this.$store.state.selectedAcademy + "/memberships";
    this.getPaymentTypes();
    Api()
      .get("admins/academy/" + this.$store.state.managedAcademy + "/products/public/memberships")
      .then((response) => {
        if (response && response.data) {
          this.academyBillDay = response.data.academyBillDay;
          this.configuration = response.data.configuration;
          if (this.configuration && !this.configuration.useBillingDate)
            this.configuration.prorate = false;
          let availableTmp = [];
          if (response.data.memberships.length > 0) {
            for (const m of response.data.memberships) {
              this.allMemberships[m._id] = m;
              availableTmp.push({ value: m._id, text: m.name + (m.type == 'service' ? ' (' + this.$t('message.automatic') + ')' : '') });
            }
          }
          if (response.data.order.length > 0) {
            this.order = response.data.order;
            this.publicMemberships = [];
            for (const o of this.order) {
              if (this.allMemberships[o])
                this.publicMemberships.push(this.allMemberships[o]);
            }
          }
          this.availableMemberships = availableTmp;
          this.colors = response.data.colors;
          this.selectedPaymentOptions = response.data.paymentMethods;

          //Packages
          if (response.data.packages && response.data.packages.length > 0) {
            console.log()
            this.availablePackages = [];
            this.orderPackages = response.data.orderPackages;
            for (const p of response.data.packages) {
              if (this.orderPackages.indexOf(p._id.toString()) < 0)
                this.availablePackages.push({ value: p._id, text: p.name });
              this.allPackages[p._id] = p;
            }
            //Add the visible ordered list
            if (this.orderPackages && this.orderPackages.length > 0) {
              this.publicPackages = [];
              for (const p of this.orderPackages)
                this.publicPackages.push(this.allPackages[p]);
            }
          }
          this.loading = false;
        }
      }).catch((e) => {
        console.log(e)
        this.loading = false;
        this.showAlert(
          "error",
          this.$t('message.oops_not_working')
        );
      });
  },
  methods: {
    moveOrder(currentPosition, up, forPackage) {
      if (forPackage) {
        let newPosition = 0;
        let oldPosition = currentPosition;
        const currentPositionElement = this.orderPackages[currentPosition];
        if (up && currentPosition > 0)
          newPosition = oldPosition - 1;
        else
          newPosition = oldPosition + 1;
        const oldOrder = this.orderPackages;
        this.orderPackages[oldPosition] = oldOrder[newPosition];
        this.orderPackages[newPosition] = currentPositionElement;
        this.publicPackages = [];
        for (const o of this.orderPackages) {
          if (this.allPackages[o])
            this.publicPackages.push(this.allPackages[o]);
        }
      } else {
        let newPosition = 0;
        let oldPosition = currentPosition;
        const currentPositionElement = this.order[currentPosition];
        if (up && currentPosition > 0)
          newPosition = oldPosition - 1;
        else
          newPosition = oldPosition + 1;
        const oldOrder = this.order;
        this.order[oldPosition] = oldOrder[newPosition];
        this.order[newPosition] = currentPositionElement;
        this.publicMemberships = [];
        for (const o of this.order) {
          if (this.allMemberships[o])
            this.publicMemberships.push(this.allMemberships[o]);
        }
      }
    },
    updateConfiguration() {
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/products/public/memberships/configuration", {
          configuration: this.configuration,
          academyBillDay: this.academyBillDay,
        })
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch((e) => {
          if (e) {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
      this.configurationDialog = false;
    },
    getPaymentTypes() {
      Api()
        .get(
          "payments/academy/" +
          this.$store.state.managedAcademy +
          "/paymenttypes"
        )
        .then((response) => {
          if (response.data && response.data.paymentMethods && response.data.paymentMethods.length == 2) {
            this.paymentTypes.push({ text: this.$t("message.credit_card"), value: 'card' });
            this.paymentTypes.push({ text: this.$t("message.ach"), value: response.data.paymentMethods[1] });
          }
        });
    },
    getGroupKey(el, p) {
      if (el && el._id) {
        return (p ? p + "_" : 'tg_') + el._id
      } else {
        console.log('Element has no value to generate tg group')
        return (p ? p : 'tg') + (Math.floor(Date.now() / 1000));
      }
    },
    updatePublicMemberships() {
      if (this.publicMemberships || this.publicPackages) {
        const newOrder = [];
        const newOrderPackages = [];
        if (this.publicMemberships)
          for (const m of this.publicMemberships) {
            if (m)
              newOrder.push(m._id);
          }
        if (this.publicPackages)
          for (const p of this.publicPackages) {
            if (p)
              newOrderPackages.push(p._id);
          }
        Api()
          .patch("admins/academy/" + this.$store.state.managedAcademy + "/products/public/memberships/order", {
            paymentMethods: this.selectedPaymentOptions,
            order: newOrder,
            orderPackages: newOrderPackages
          })
          .then(() => {
            this.showAlert("success", this.$t("message.updated"));
          })
          .catch((e) => {
            if (e) {
              this.showAlert("error", this.$t("message.error_generic"));
            }
          });
      }
    },//this.updatePublicMemberships();
    removeElement(id, forPackage) {
      if (forPackage) {
        const p = this.allPackages[id];
        if (p) {
          this.availablePackages.push({ value: p._id, text: p.name });
          let index = 0;
          for (const p of this.publicPackages) {
            if (p._id == id) {
              this.publicPackages.splice(index, 1);
              break;
            }
            index++;
          }
        }
      } else {
        const m = this.allMemberships[id];
        if (m) {
          this.availableMemberships.push({ value: m._id, text: m.name + (m.type == 'service' ? ' (' + this.$t('message.automatic') + ')' : '') });
          let index = 0;
          for (const m of this.publicMemberships) {
            if (m._id == id) {
              this.publicMemberships.splice(index, 1);
              break;
            }
            index++;
          }
        }
      }
    },
    addPackage(id) {
      if (!this.publicPackages)
        this.publicPackages = [];
      this.publicPackages.push(this.allPackages[id]);
      this.orderPackages.push(id)
      let index = 0;
      for (const i of this.availablePackages) {
        if (i.value == id) {
          this.availablePackages.splice(index, 1);
          return;
        }
        index++;
      }
    },
    addMembership(id) {
      if (!this.publicMemberships)
        this.publicMemberships = [];
      this.publicMemberships.push(this.allMemberships[id]);
      if (!this.order)
        this.order = [];
      this.order.push(id)
      let index = 0;
      for (const m of this.availableMemberships) {
        if (m.value == id) {
          this.availableMemberships.splice(index, 1);
          return;
        }
        index++;
      }
    },
    copyMembershipsUrl() {
      console.log(this.membershipsUrl)
      let urlToCopy = this.membershipsUrl + '?embed=false';
      this.copyToClipboard(urlToCopy);
    },
    copyMembershipsEmbedCode() {
      let urlToCopy = this.membershipsUrl + '?embed=true';
      let textToCopy = '<iframe style="width:100%;height:330px" frameBorder="0" src="' + (urlToCopy) + '"></iframe>';
      this.copyToClipboard(textToCopy);
    },
    openMembershipsQRCode() {
      let buff = new Buffer(this.membershipsUrl);
      const encodedUrl = buff.toString("base64");
      window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=memberships&');
    },
    openMembershipsUrl() {
      if (this.isSmallerDisplay())
        this.copyToClipboard(this.membershipsUrl);
      else
        window.open(this.membershipsUrl);
    },
    updatePublicUrl() {
      this.publicScheduleUrl = 'https://core.bjjlink.com/pub/academy/' + this.$store.state.selectedAcademy + '/schedule?' + (this.dark ? 'theme=dark' : '');
      this.displayExternalSchedule = false;
      const vm = this;
      setTimeout(function () {
        vm.displayExternalSchedule = true;
      }, 1000)
    },
  },
};
</script>

<style scoped></style>
